(function(){function patch(){document.querySelectorAll('.jsq-home-v2 .product-img img').forEach(function(img){img.style.objectFit='contain';img.style.padding='10px';img.style.background='#fffaf2';});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',patch);else patch();})();

(function () {
  'use strict';

  function init() {
    var form = document.querySelector('.js-app-bar__search');
    if (!form || form.getAttribute('data-predict-wired')) return;
    var input = form.querySelector('input[type="search"]');
    if (!input) return;
    form.setAttribute('data-predict-wired', '1');

    var labels = {};
    try { labels = JSON.parse(form.getAttribute('data-search-texts') || '{}'); } catch (error) {}
    var searchUrl = form.getAttribute('action');
    var suggestUrl = form.getAttribute('data-suggest-url');
    var currency = form.getAttribute('data-currency');
    var locale = form.getAttribute('data-locale');
    var formatter;
    try { formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }); } catch (error) {}

    if (!document.getElementById('js-appbar-predict-css')) {
      var css = document.createElement('style');
      css.id = 'js-appbar-predict-css';
      css.textContent = [
        '.js-app-bar__search-wrap{position:relative;}',
        '.js-appbar-results{position:absolute;top:calc(100% - 3px);left:12px;right:12px;z-index:250;background:#fffdf8;border:1px solid #efe5cf;border-radius:14px;box-shadow:0 14px 30px rgba(0,0,0,.18);max-height:min(70vh,460px);overflow-y:auto;-webkit-overflow-scrolling:touch;padding:4px 0 6px;}',
        '.js-appbar-results[hidden]{display:none;}',
        '.js-appbar-results .sec{padding:12px 16px 4px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.16em;color:#78603e;margin:0;}',
        '.js-appbar-results .row{display:flex;gap:12px;align-items:center;min-height:60px;padding:9px 16px;text-decoration:none;color:#1a120b;-webkit-tap-highlight-color:rgba(184,148,85,.15);}',
        '.js-appbar-results [role="option"][aria-selected="true"],.js-appbar-results .row:active{background:#fbf3e2;outline:2px solid #8b6844;outline-offset:-2px;}',
        '.js-appbar-results .row img,.js-appbar-results .row .ph{width:44px;height:44px;min-width:44px;border-radius:8px;object-fit:contain;background:#fbf3e2;flex:0 0 auto;display:grid;place-items:center;font-size:18px;}',
        '.js-appbar-results .row .b{flex:1;min-width:0;}',
        '.js-appbar-results .row .t{display:block;font-size:14px;font-weight:500;margin:0 0 2px;line-height:1.3;}',
        '.js-appbar-results .row .m{font-size:12px;color:#5a4f43;margin:0;display:flex;gap:8px;align-items:baseline;flex-wrap:wrap;}',
        '.js-appbar-results .row .m strong{color:#1a120b;font-weight:600;}',
        '.js-appbar-results .stock{font-size:12px;color:#8b3a4a;}',
        '.js-appbar-results .all{display:block;padding:12px 16px;border-top:1px solid #efe5cf;margin-top:4px;font-size:14px;font-weight:600;color:#8b3a4a;text-decoration:none;text-align:center;}',
        '.js-appbar-results .none{padding:18px 16px;text-align:center;color:#5a4f43;font-size:14px;}',
        '.js-appbar-status{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;}'
      ].join('');
      document.head.appendChild(css);
    }

    var wrap = document.createElement('div');
    wrap.className = 'js-app-bar__search-wrap';
    form.parentNode.insertBefore(wrap, form);
    wrap.appendChild(form);
    var panel = document.createElement('div');
    panel.id = 'js-appbar-search-results';
    panel.className = 'js-appbar-results';
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', labels.suggestions);
    panel.hidden = true;
    wrap.appendChild(panel);
    var status = document.createElement('div');
    status.className = 'js-appbar-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    wrap.appendChild(status);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');

    var timer, controller, requestVersion = 0, activeIndex = -1, renderedQuery = '';
    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, function (character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
      });
    }
    function text(key, values) {
      return String(labels[key] || '').replace(/__(QUERY|PRICE|COUNT)__/g, function (token, name) {
        name = name.toLowerCase();
        return values && values[name] !== undefined ? String(values[name]) : token;
      });
    }
    function query() {
      var value = input.value.trim();
      return /^(?:24[\s\-\/]*(?:6|six)|twenty\s+four\s+six)(?:\s+player)?$/i.test(value) ? '24Six' : value;
    }
    function cancel() {
      clearTimeout(timer);
      requestVersion += 1;
      if (controller) controller.abort();
      controller = null;
      input.setAttribute('aria-busy', 'false');
    }
    function close(clear) {
      panel.hidden = true;
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      panel.querySelectorAll('[role="option"]').forEach(function (option) { option.setAttribute('aria-selected', 'false'); });
      if (clear) { panel.innerHTML = ''; renderedQuery = ''; }
    }
    function show() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function fullSearch(q) {
      return searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    }
    function price(product) {
      var raw = product.price_min !== undefined ? product.price_min : product.price;
      if (raw === undefined || raw === null || raw === '') return '';
      var amount = Number(raw);
      if (!Number.isFinite(amount) || amount < 0) return '';
      var formatted = formatter ? formatter.format(amount) : currency + ' ' + amount.toFixed(2);
      return Number(product.price_max) > amount ? text('from', { price: formatted }) : formatted;
    }
    function thumbnail(product) {
      var source = product.image || (product.featured_image && product.featured_image.url);
      if (!source) return '<span class="ph" aria-hidden="true">◇</span>';
      try {
        var imageUrl = new URL(source, document.baseURI);
        imageUrl.searchParams.set('width', '88');
        source = imageUrl.href;
      } catch (error) {}
      return '<img src="' + escapeHtml(source) + '" width="44" height="44" alt="" loading="lazy">';
    }
    // Distinguish verified collections that share a title; keep every destination intact.
    function collectionTitle(collection) {
      var handle;
      try {
        var path = new URL(collection.url, document.baseURI).pathname;
        var match = path.match(/\/collections\/([^/]+)\/?$/);
        handle = match && match[1];
      } catch (error) {}
      if (handle === 'amj-kiddush-cups') return 'Kiddush Cups — Available Online';
      if (handle === 'kiddush-cups-trays') return 'Kiddush Cups, Fountains & Sets';
      return collection.title || '';
    }
    function render(q, data) {
      var resources = data && data.resources && data.resources.results || {};
      var products = resources.products || [], collections = resources.collections || [];
      var html = '', optionIndex = 0;
      function option(className, href, body) {
        return '<a class="' + className + '" role="option" aria-selected="false" tabindex="-1" id="js-appbar-option-' + optionIndex++ + '" href="' + escapeHtml(href) + '">' + body + '</a>';
      }
      if (products.length) {
        html += '<p class="sec" role="presentation">' + escapeHtml(text('products')) + '</p>';
        products.forEach(function (product) {
          var amount = price(product);
          html += option('row', product.url, thumbnail(product) + '<span class="b"><span class="t" dir="auto">' + escapeHtml(product.title || '') + '</span><span class="m">' +
            (product.vendor ? '<span>' + escapeHtml(product.vendor) + '</span>' : '') +
            (amount ? '<strong>' + escapeHtml(amount) + '</strong>' : '') +
            (product.available === false ? '<span class="stock">' + escapeHtml(text('sold_out')) + '</span>' : '') + '</span></span>');
        });
      }
      if (collections.length) {
        html += '<p class="sec" role="presentation">' + escapeHtml(text('collections')) + '</p>';
        collections.forEach(function (collection) {
          html += option('row', collection.url, '<span class="ph" aria-hidden="true">◇</span><span class="b"><span class="t" dir="auto">' + escapeHtml(collectionTitle(collection)) + '</span></span>');
        });
      }
      if (!products.length && !collections.length) html += '<p class="none" role="presentation">' + escapeHtml(text('no_matches', { query: q })) + '</p>';
      html += option('all', fullSearch(q), escapeHtml(text('all_results', { query: q })) + ' <span aria-hidden="true">→</span>');
      panel.innerHTML = html;
      activeIndex = -1;
      renderedQuery = q;
      input.removeAttribute('aria-activedescendant');
      status.textContent = products.length + collections.length ? text('status', { count: products.length + collections.length }) : text('no_matches', { query: q });
      show();
    }
    function run(q, version) {
      controller = typeof AbortController === 'function' ? new AbortController() : null;
      input.setAttribute('aria-busy', 'true');
      status.textContent = text('loading');
      var url = suggestUrl + '?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product%2Ccollection&resources%5Blimit%5D=6' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&resources%5Boptions%5D%5Bfields%5D=title%2Cvendor%2Cproduct_type%2Cvariants.title%2Cvariants.sku%2Cbody';
      fetch(url, { signal: controller ? controller.signal : undefined, headers: { 'Accept': 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); })
        .then(function (data) {
          if (version !== requestVersion || query() !== q) return;
          input.setAttribute('aria-busy', 'false');
          render(q, data);
        })
        .catch(function (error) {
          if (version !== requestVersion || error && error.name === 'AbortError') return;
          input.setAttribute('aria-busy', 'false');
          close(true);
          status.textContent = text('error');
        });
    }
    input.addEventListener('input', function () {
      cancel();
      close(true);
      status.textContent = '';
      var q = query(), version = requestVersion;
      if (q.length < 2) return;
      timer = setTimeout(function () { run(q, version); }, 180);
    });
    input.addEventListener('focus', function () { if (renderedQuery === query() && panel.innerHTML) show(); });
    // The early submit guard delegates only a current, explicitly selected suggestion.
    form.jsqActivateSelectedSuggestion = function (event) {
      if (panel.hidden || renderedQuery !== query() || activeIndex < 0) return false;
      var selected = panel.querySelectorAll('[role="option"]')[activeIndex];
      if (!selected || selected.getAttribute('aria-selected') !== 'true' ||
          input.getAttribute('aria-activedescendant') !== selected.id) return false;
      event.preventDefault();
      event.stopImmediatePropagation();
      selected.click();
      cancel();
      close(false);
      return true;
    };
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { cancel(); close(false); status.textContent = ''; return; }
      if (event.key === 'Tab') { cancel(); close(false); return; }
      if (panel.hidden) return;
      var options = Array.from(panel.querySelectorAll('[role="option"]'));
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (!options.length) return;
        event.preventDefault();
        activeIndex = event.key === 'ArrowDown' ? (activeIndex + 1) % options.length : (activeIndex <= 0 ? options.length - 1 : activeIndex - 1);
        options.forEach(function (option, index) { option.setAttribute('aria-selected', String(index === activeIndex)); });
        input.setAttribute('aria-activedescendant', options[activeIndex].id);
        options[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && activeIndex >= 0 && options[activeIndex]) {
        form.jsqActivateSelectedSuggestion(event);
      }
    });
    document.addEventListener('click', function (event) { if (!wrap.contains(event.target)) { cancel(); close(false); } });
    form.addEventListener('submit', function () { input.value = query(); cancel(); close(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ==== SPRINT2.1 reveal-on-scroll (2026-07-04) ====
   Sections/cards fade+rise 12px with a 40ms stagger as they enter the
   viewport. JS adds .jsq-reveal so no-JS visitors see everything; skips
   entirely under prefers-reduced-motion or without IntersectionObserver. */
(function(){
  function initReveal(){
    if(!('IntersectionObserver' in window))return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var els=document.querySelectorAll('.jsq-cg__grid > *, .jsq-tiles__grid > *, .js-footer__cols > *');
    if(!els.length)return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('is-inview');io.unobserve(e.target);}
      });
    },{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el,i){
      var r=el.getBoundingClientRect();
      if(r.top<window.innerHeight&&r.bottom>0){return;} /* already on screen: never hide first paint */
      el.style.setProperty('--stagger',(i%6)*40+'ms');
      el.classList.add('jsq-reveal');
      io.observe(el);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initReveal);
  else initReveal();
})();
